module.exports = __webpack_public_path__ + "img/Frame-65.b5963859.svg";